import { BaseEntityClass } from "@shared/services/event_tracking/entities/base_entity_class";

interface SellSheetEntityParams {
  sheetId: number;
  sfProductVersionId?: number;
  productId?: number;
  productLineId?: number;
  orderId?: number;
}

export class SellSheetEntity extends BaseEntityClass {
  sheetId: number;
  sfProductVersionId?: number;
  productId?: number;
  productLineId?: number;
  orderId?: number;

  constructor(params: SellSheetEntityParams) {
    super();
    this.type = "sell_sheet";
    this.entity_version = 2;
    this.sheetId = params.sheetId;
    this.sfProductVersionId = params.sfProductVersionId;
    this.productId = params.productId;
    this.productLineId = params.productLineId;
    this.orderId = params.orderId;
  }
}
